// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 13H14.5V22H9.5V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 2H22V22H16.5V11H13V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H11V11H7.5V22H2V2Z"}}]};

const Dam4FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-4-filled',
    ref,
    icon: element,
  },
));

Dam4FilledIcon.displayName = 'Dam4FilledIcon';

export default Dam4FilledIcon;
